setTimeout(function() {
  $(function() {
    var newsletter_model = $('[data-newsletter_model]');
    var newsletter_tab = $('[data-newsletter-tab]');
    var subscriptionKey = 'newsletter_subscribed',
      knownUnsubscribed = newsletter_model.data('newsletter-customer-status') === 'unsubscribed',
      signupSucceeded = newsletter_model.find('[data-newsletter-signup-success]').length > 0;

    // Shopify's current status overrides previously saved guest signup preferences.
    if (knownUnsubscribed) {
      try { window.localStorage.removeItem(subscriptionKey); } catch (_) { /* Storage may be unavailable. */ }
      $.removeCookie(subscriptionKey, { path: '/' });
    }

    function hasSubscribed() {
      if (signupSucceeded) return true;
      if (knownUnsubscribed) return false;
      try {
        if (window.localStorage.getItem(subscriptionKey) === 'true') return true;
      } catch (_) { /* Keep the popup working when storage is blocked. */ }
      return $.cookie(subscriptionKey) === 'true';
    }

    if (hasSubscribed()) {
      try {
        window.localStorage.setItem(subscriptionKey, 'true');
        // Migrate the old cookie only after the preference is saved successfully.
        $.removeCookie(subscriptionKey, { path: '/' });
      } catch (_) { /* Retain any existing cookie if storage cannot be written. */ }
      newsletter_tab.prop('hidden', true);
      return;
    }
    if (!newsletter_model.length) return;

    var delay = newsletter_model.data('delay'),
      expire = newsletter_model.data('expire'),
      mobile = window.matchMedia('(max-width: 767px)'),
      autoOpenTimer,
      previousFocus,
      inactivityDuration = 30 * 60 * 1000,
      lastRenewal = 0;

    function saveDismissal(key) {
      $.cookie(key, 'closed', { expires: new Date(Date.now() + inactivityDuration), path: '/' });
    }

    function renewDismissals() {
      if (document.visibilityState === 'hidden') return;
      ['newsletter_tab', 'newsletter_popup_dismissed'].forEach(function(key) {
        if ($.cookie(key) === 'closed') saveDismissal(key);
      });
      lastRenewal = Date.now();
    }

    function recordActivity() {
      // Limit writes during scrolling and repeated keyboard input.
      if (Date.now() - lastRenewal < 1000) return;
      renewDismissals();
      if (!$('body').hasClass('newsletter-model-visibale')) showTab();
    }

    // Renew only short dismissals; newsletter_model is reserved for the checkbox preference.
    renewDismissals();
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function(eventName) {
      document.addEventListener(eventName, recordActivity, { passive: true });
    });
    window.addEventListener('focus', recordActivity);
    document.addEventListener('visibilitychange', recordActivity);

    function mobileDisabled() {
      return newsletter_model.data('disable-mobile') === true && mobile.matches;
    }

    function showTab() {
      newsletter_tab.prop('hidden', hasSubscribed() || $.cookie('newsletter_model') === 'closed' || $.cookie('newsletter_tab') === 'closed' || mobileDisabled());
    }

    function openNewsletter() {
      if (mobileDisabled() || hasSubscribed()) return;
      clearTimeout(autoOpenTimer);
      previousFocus = document.activeElement;
      newsletter_tab.prop('hidden', true);
      $('[data-newsletter-open]').attr('aria-expanded', 'true');
      $('body').addClass('newsletter-model-visibale');
      newsletter_model.attr('aria-hidden', 'false').show();
      newsletter_model.find('input[type="email"]').trigger('focus');
    }

    function dismissNewsletter() {
      if (!$('body').hasClass('newsletter-model-visibale')) return;
      saveDismissal('newsletter_popup_dismissed');
      $('body').removeClass('newsletter-model-visibale');
      newsletter_model.hide().attr('aria-hidden', 'true');
      $('[data-newsletter-open]').attr('aria-expanded', 'false');
      showTab();
      if (previousFocus && document.contains(previousFocus) && !mobileDisabled()) previousFocus.focus();
    }

    $('[data-newsletter-open]').click(function(e) {
      e.stopPropagation();
      openNewsletter();
    });
    $('[data-newsletter-tab-close]').click(function(e) {
      e.stopPropagation();
      clearTimeout(autoOpenTimer);
      saveDismissal('newsletter_tab');
      newsletter_tab.prop('hidden', true);
    });
    newsletter_model.find('.model-close').click(dismissNewsletter);
    $(document).keydown(function(e) {
      if (!$('body').hasClass('newsletter-model-visibale')) return;
      if (e.which == 27) dismissNewsletter();
      if (e.key === 'Tab') {
        var focusable = newsletter_model.find('button, input, a[href], select, textarea, [tabindex="0"]').filter(':visible'),
          first = focusable[0],
          last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
    $(document).click(function(e) {
      if (!$(e.target).closest('.newsletter-model .model-box').length) dismissNewsletter();
    });
    newsletter_model.find('#dismiss_show').change(function() {
      if ($(this).prop('checked')) {
        $.cookie('newsletter_model', 'closed', { expires: expire, path: '/' });
      } else {
        $.removeCookie('newsletter_model', { path: '/' });
      }
    });

    showTab();
    mobile.addEventListener('change', function() {
      if (mobileDisabled()) dismissNewsletter();
      if (!$('body').hasClass('newsletter-model-visibale')) showTab();
    });

    newsletter_model.removeClass('d-none');
    if (newsletter_model.find('.newsletter-form input[aria-invalid="true"]').length) {
      openNewsletter();
    } else if (newsletter_model.data('auto-open') === true) {
      autoOpenTimer = setTimeout(function() {
        if ($.cookie('newsletter_model') !== 'closed' && $.cookie('newsletter_popup_dismissed') !== 'closed' && $.cookie('newsletter_tab') !== 'closed') {
          openNewsletter();
        }
      }, delay);
    }
  });
}, 150);
